import React from 'react'
import styles from '../../styles.module.css'


const fmt = (v) => (v === null || v === undefined || v === '') ? '—' : v

const CATEGORIES = [
  { key: 'total',       label: 'Всего' },
  { key: 'leadership',  label: 'Руководящий состав' },
  { key: 'admin',       label: 'Административный персонал' },
  { key: 'pedagogical', label: 'Педагогические работники' },
]


const getAwardsList = (row) => {
  const awards = row?.awards
  if (!awards) return []
  return Array.isArray(awards) ? awards : [awards]
}


const AwardsTable = ({ row }) => {

  const awards = getAwardsList(row)

  if (!awards.length) return null

  const totalCols = awards.length * CATEGORIES.length

  return (
    <table className={styles.mainTable}>
      <thead>
        <tr className={styles.titleRow}>
          <th className={styles.titleLeft} colSpan={totalCols - 1}>Сведения о награжденных работниках</th>
          <th className={styles.titleRight}>Форма №3/СВУ</th>
        </tr>
        <tr className={`${styles.titleRow} ${styles.secondTitleRow}`}>
          <th className={styles.titleLeft} colSpan={totalCols - 1}>{row.organizationName}</th>
          <th className={styles.titleRight}>Таблица №3</th>
        </tr>
        <tr>
          {awards.map(a => (
            <th key={a.typeId} colSpan={CATEGORIES.length} /* className={styles.vertical} */>{a.typeName}</th>
          ))}
        </tr>
        <tr>
          {awards.map(a => (
            <React.Fragment key={a.typeId}>
              {CATEGORIES.map(c => <th key={c.key} className={styles.vertical}>{c.label}</th>)}
            </React.Fragment>
          ))}
        </tr>
      </thead>
      <tbody>
        <tr className={styles.sectionRow}>
          <td colSpan={totalCols}>За отчетный учебный год</td>
        </tr>
        <tr>
          {awards.map(a => (
            <React.Fragment key={a.typeId}>
              {CATEGORIES.map(c => <td key={c.key}>{fmt(a.forYear?.[c.key])}</td>)}
            </React.Fragment>
          ))}
        </tr>
        <tr className={styles.sectionRow}>
          <td colSpan={totalCols}>Всего</td>
        </tr>
        <tr>
          {awards.map(a => (
            <React.Fragment key={a.typeId}>
              {CATEGORIES.map(c => <td key={c.key}>{fmt(a.cumulative?.[c.key])}</td>)}
            </React.Fragment>
          ))}
        </tr>
      </tbody>
    </table>
  )
}

export default AwardsTable
